<template>
    <el-popover
        placement="bottom"
        width="134"
        popper-class="data-grid-toolbar-popper"
        trigger="click"
        v-model="visible">
        <el-radio-group v-model="value" @change="onChange">
            <el-radio label="medium" name="medium">大</el-radio>
            <el-radio label="small" name="small">中</el-radio>
            <el-radio label="mini" name="mini">小</el-radio>
        </el-radio-group>
        <!-- <div class="footer">
            <el-button size="mini" @click="visible = false">取消</el-button>
            <el-button type="primary" size="mini" @click="onChange">确认</el-button>
        </div> -->
    <item slot="reference"  :icon="icon" name="尺寸"/>
  </el-popover>
</template>

<script>
import icon from '../icons/size.svg'
import Item from './item'
export default {
    components: {
        Item
    },
    props: {
        size: {
            type: String,
            default: 'small'
        }
    },
    data () {
        return {
            value: '',
            icon,
            visible: false,
            loading: false
        }
    },
    watch: {
        size: {
            immediate: true,
            handler (val) {
                this.value = val
            }
        }
    },
    methods: {
        onChange (value) {
            this.$emit('change', this.value)
            setTimeout(() => {
                this.visible = false
            }, 0)
        }
    }
}
</script>

<style lang="less">
.data-grid-toolbar-popper {
    min-width: 0px;
    .el-radio {
        display: block;
        margin-bottom: 10px;
    }
    .el-button--mini {
        padding: 4px 12px!important;
    }
    .el-button+.el-button {
        margin-left: 4px!important;
    }
    .footer {
        margin-top: 10px
    }
}
</style>


// WEBPACK FOOTER //
// src/components/framework/data-grid/toolbar/size.vue